/** @file readScope: validates `template.instantiate.scope` (CR-002) at its input path. */
import { failField } from '@zilo/pose3d-format/validate/fields/failField';
import type { TemplateScope } from '../types/puppetInputs';
import { compact } from '../validate/compact';
import { readInput } from '../validate/readInput';

const DIRECTIONS = [1, 2, 4, 8, 16] as const;

/** `{ directions?: 1|2|4|8|16, pitch?: none|basic|full, camera?: iso|side }`; VALIDATION at the field otherwise. */
export function readScope(value: unknown, path: string): TemplateScope {
  const r = readInput(value, path, ['directions', 'pitch', 'camera']);
  const directions = (k: string): NonNullable<TemplateScope['directions']> => {
    const v = r.raw(k);
    return DIRECTIONS.find((d) => d === v) ?? failField(r.at(k), `one of ${DIRECTIONS.join(', ')}`, v);
  };
  return compact({
    directions: r.opt('directions', directions),
    pitch: r.opt('pitch', (k) => r.oneOf(k, ['none', 'basic', 'full'] as const)),
    camera: r.opt('camera', (k) => r.oneOf(k, ['iso', 'side'] as const)),
  });
}
